import dayjs from 'dayjs';
import { FormatType, TransformedLocaleConfig } from '@byted/date-fmt/dist/type';
import BDDateFmt from '@byted/date-fmt';
export const formatI18NTime = (time, local, type = 'DD MMMM YYYY') => {
  return dayjs(time).locale(local).format(type);
};
export const getFormater = (localConfig: TransformedLocaleConfig) => {
  if (localConfig.meridiem) {
    eval('localConfig.meridiem = ' + localConfig.meridiem);
  }

  BDDateFmt.setLocaleConfig(localConfig);
  return (date: number | Date, formatType: FormatType) => {
    return BDDateFmt.format(date, formatType);
  };
};
export const beautifyTimeNumber = (number: number) => {
  return String(number).padStart(2, '0');
};